import { render, staticRenderFns } from "./FileImportDescriptionDialog.vue?vue&type=template&id=198f9612&scoped=true"
import script from "./FileImportDescriptionDialog.vue?vue&type=script&lang=ts"
export * from "./FileImportDescriptionDialog.vue?vue&type=script&lang=ts"
import style0 from "./FileImportDescriptionDialog.vue?vue&type=style&index=0&id=198f9612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f9612",
  null
  
)

export default component.exports